
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { adminUpdateUyeDoc, removeAdminUserDocItem } from "../../features/admin2/admin2Slice"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import Btn from "../shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"
import { toast } from "react-toastify"
import  { validateFile } from "../../helper/docs/validateFile"
import ImageUploader from "../docs/ImageUploader"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    color: ${({theme}) => theme.mainTextColor};

    .top-container{
        width: 100%;

        h4{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
        }
    }

    .doc-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 30px;
        width: 100%;
        padding: 20px 0;
        height: 500px;
        max-height: 500px;
        overflow: auto;
        border-top: 1px solid ${({theme})=> theme.mainTextColor};

        &::-webkit-scrollbar {
            width: 0;
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
           
        
        .doc-item{
            width: calc(50% - 15px);
            height: 400px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }
            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
                background-color: #ff000040;
            }
        }

    }

    .btn-container{
        display: flex;
        justify-content: center;
        gap: 50px;
        width: 100%;
        padding: 20px 0;
        border-top: 1px solid ${({theme}) => theme.mainBorderColor};
    }
`

// Zararlı kodları tespit eden regex kalıpları
const maliciousPatterns = [
  /eval\s*\(/i,
  /new\s+Function\s*\(/i,
  /setTimeout\s*\(/i,
  /setInterval\s*\(/i,
  /document\.write\s*\(/i,
  /<script>/i,
  /objShell/i, 
  /.shell/i,
  /.wscript/i,
  /window\.location\s*=/i,          
  /document\.cookie/i,              
  /onerror\s*=/i,                   
  /src\s*=\s*["']javascript:/i,
  /Set\s+objShell\s*=\s*CreateObject\("WScript\.Shell"\)/i,  // objShell Shell oluşturulması
  /objShell\.Run\s*\("cmd\.exe\s*\/c\s*calc\.exe"/i  // Komut satırı üzerinden zararlı komut
];

const AdminUyeDoc = () => {
    const {uyeItemData, isLoadingUpdateUyeDoc } = useSelector(state => state.admin2)
    const dispatch = useDispatch()

    const [fileList, setFileList] = useState([
        {
            selectedFile: null,
            loadedBefore: uyeItemData.kimlik ? uyeItemData.kimlik : null,
            fileTypeName: "Kimlik",
            staticValue: "kimlik"
        },
        {
            selectedFile: null,
            loadedBefore: uyeItemData.ehliyetPhoto ? uyeItemData.ehliyetPhoto : null,
            fileTypeName: "Ehliyet",
            staticValue: "ehliyet"
        },
        {
            selectedFile: null,
            loadedBefore: uyeItemData.srcPhoto ? uyeItemData.srcPhoto : null,
            fileTypeName: "SRC Belgesi",
            staticValue: "src"
        },
        {
            selectedFile: null,
            loadedBefore: uyeItemData.referansFaturası ? uyeItemData.referansFaturası : null,
            fileTypeName: "Referans Faturası",
            staticValue: "fatura"
        },
        {
            selectedFile: null,
            loadedBefore: uyeItemData.vergiLevhası ? uyeItemData.vergiLevhası : null,
            fileTypeName: "Vergi Levhası",
            staticValue: "vergiLevhası"
        },
        {
            selectedFile: null,
            loadedBefore: uyeItemData.diger1 ? uyeItemData.diger1 : null,
            fileTypeName: "Diğer-1",
            staticValue: "diğer-1"
        },
        {
            selectedFile: null,
            loadedBefore: uyeItemData.diger2 ? uyeItemData.diger2 : null,
            fileTypeName: "Diğer-2",
            staticValue: "diğer-2"
        },
    ])

  
const handleFileSelect = async (index, files) => {

  const file = await validateFile({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})

  if(file){
    // Tüm kontroller başarılıysa, dosyayı fileList'e ekliyoruz
    const newUploads = [...fileList];
    newUploads[index].selectedFile = file;
    setFileList(newUploads);
  };

}

      const handleSubmit = async () => {
        const updatedItems = fileList.filter(item => item.selectedFile);
        const results = [];
        for (const [index, item] of updatedItems.entries()) {
          try {
            const result = await dispatch(adminUpdateUyeDoc({
              userName: uyeItemData.phoneNumber,
              documentType: item.staticValue,
              imageFile: item.selectedFile
            }));
results.push({ status: "fulfilled", value: result });
            if(result.meta.requestStatus === "fulfilled"){
                toast.success(`${item.fileTypeName} belgesi başarıyla sisteme yüklendi.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            else{
                toast.error(`${item.fileTypeName} sisteme yüklenemedi.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

          } catch (error) {
            console.log(error);
            results.push({ status: "rejected", reason: error });
            
          }
        }

        const latestData = results[results.length-1]?.value?.payload
        
        setFileList([
            {
                selectedFile: null,
                loadedBefore:  latestData.kimlik ? latestData.kimlik : null,
                fileTypeName: "Kimlik",
                staticValue: "kimlik"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.ehliyetPhoto ? latestData.ehliyetPhoto : null,
                fileTypeName: "Ehliyet",
                staticValue: "ehliyet"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.srcPhoto ? latestData.srcPhoto : null,
                fileTypeName: "SRC Belgesi",
                staticValue: "src"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.referansFaturası ? latestData.referansFaturası : null,
                fileTypeName: "Referans Faturası",
                staticValue: "fatura"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.vergiLevhası ? latestData.vergiLevhası : null,
                fileTypeName: "Vergi Levhası",
                staticValue: "vergiLevhası"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.diger1 ? latestData.diger1 : null,
                fileTypeName: "Diğer-1",
                staticValue: "diğer-1"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.diger2 ? latestData.diger2 : null,
                fileTypeName: "Diğer-2",
                staticValue: "diğer-2"
            },
        ])
      };


      const handleRemoveDoc = async(fileItem) => {
       const result = await dispatch(removeAdminUserDocItem({userId: uyeItemData.id, documentType: fileItem.staticValue}));

       if(result.meta.requestStatus === "fulfilled"){
            setFileList(fileList.map(item => {
                if(item.staticValue === fileItem.staticValue){
                    return {...item, loadedBefore: null}
                }
                else{
                    return item
                }
            }))
        }
      }




  return (
    <Container>
        <div className="top-container">
            <h4>Adı Soyadı: {uyeItemData.adSoyadUnvan}</h4>
            <div className="doc-list">
                {
                    fileList.map((fileItem, index) => {
                        let previewSrc;
                        let isPdf;
                        if (fileItem.selectedFile) {
                            isPdf = fileItem.selectedFile.type === "application/pdf"
                            previewSrc = URL.createObjectURL(fileItem.selectedFile);

                        } else if (fileItem.loadedBefore) {
                          previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                        } else {
                          previewSrc = "question";
                        }

                        return (
                            <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                 <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                    {fileItem.selectedFile ? (
                                        <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                    ) : fileItem.loadedBefore ? (
                                        <p className="action">
                                            <span></span>
                                            <span>Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</span>
                                            <button className="delete-btn" onClick={() => handleRemoveDoc(fileItem)}>Belgeyi Sil</button>
                                        </p>
                                    ) : (
                                        <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                    )}
                                </div>
                                <ImageUploader
                                    previewSrc={previewSrc}
                                    isPdf={isPdf} 
                                    onFileSelect={(files) => handleFileSelect(index, files)} 
                                />
                            </div>
                        )
                    }) 
                }
            </div>
        </div>
        <div className="btn-container">
            <Btn handleClick={handleSubmit} width={"220px"} bgColor="#E85446" color="#fff" padding="10px" isDisabled={fileList.filter(item => item.selectedFile).length < 1}>{isLoadingUpdateUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : fileList.filter(item => item.selectedFile).length < 1 ? "Değişiklik Yok":  `${fileList.filter(item => item.selectedFile).length} Değişiklik Kaydet`}</Btn>
            <Btn handleClick={() => dispatch(showModal(null))} width={"220px"} bgColor="transparent" borderColor="#E85446" color="#E85446" padding="10px">Vazgeç</Btn>
        </div>
    </Container>
  )
}

export default AdminUyeDoc

